import { mapEvtEntrySId } from '../../../shared';
import { useBondsCallLinesTransformApi } from '../api';

export const useSecuritiesBondCallCallIdList = () => {
  const response = useBondsCallLinesTransformApi({
    transformFunction: mapEvtEntrySId,
  });
  return response;
};
